import React from "react";
import ProfileLayout from "../../components/layout/ProfileLayout";
import PasswordHome from "./components/PasswordHome";

const PasswordSections = () => {
  return (
    <ProfileLayout>
      <PasswordHome />
    </ProfileLayout>
  );
};
export default PasswordSections;
